(function($) {

	'use strict';

	var init = function() {

    $('.filter__item').first().addClass('filter__item--active');

        $('.filter__item').click(function() {
			var data = $(this).data('slug');
          $('.filter__item').removeClass('filter__item--active');
		  $(this).addClass('filter__item--active');
		  $('.jobs-archive__item').each(function() {
			  var el = $(this);
			  el.show();
			  if(!el.hasClass(data) && data != "all") {
				  el.hide();
			  }
		  });
        });

	};

	$(document).ready(function() {
		init();
	});

})(jQuery);
